export default __webpack_public_path__ + "874e347094571e07a01e49bdbf5668ef.png";